import { makeStyles } from '@material-ui/core';

export const useAlertTooltipStyles = makeStyles(() => ({
  '@keyframes bounceIn': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.3)',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.05)',
    },
    '70%': {
      transform: 'scale(0.9)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  '@keyframes fadeOut': {
    '0%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '100%': {
      opacity: 0,
      transform: 'scale(0.5)',
    },
  },
  alertContainer: {
    width: 'auto',
    marginBottom: 16,
    position: 'fixed',
    top: '100px',
    zIndex: 11000,
    right: '30px',
    animation: '$bounceIn 0.5s ease-in forwards !important',
  },
  alertRoot: {
    padding: '2px 10px',
    '& .MuiAlert-action': {
      marginRight: -3,
    },
  },
  alertExiting: {
    animation: '$fadeOut 0.3s ease-in forwards !important',
  },
  customButton: {
    marginLeft: 16,
    padding: '4px 12px',
    border: 'none',
    borderRadius: 4,
    background: 'transparent',
    color: '#236BFF',
    fontWeight: 700,
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontSize: 13,
    fontFamily: "Rubik, -apple-system, BlinkMacSystemFont, \"Source Sans Pro\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", 'sans-serif'",
  },
  messageWithButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: "Rubik, -apple-system, BlinkMacSystemFont, \"Source Sans Pro\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", 'sans-serif'",
  },
  successAlert: {
    backgroundColor: '#E4FFC8',
    border: '1px solid #50AC32',
    color: '#50AC32',
    '& .MuiAlert-icon': {
      color: '#11600D',
    },
    '& .MuiAlert-message': {
      color: '#11600D',
    },
    '& .MuiAlert-action': {
      color: '#11600D',
    },
  },
  infoAlert: {
    backgroundColor: '#EFF5FF',
    border: '1px solid #1451CC',
    color: '#1451CC',
    '& .MuiAlert-icon': {
      color: '#1451CC',
    },
    '& .MuiAlert-message': {
      color: '#1451CC',
    },
    '& .MuiAlert-action': {
      color: '#1451CC',
    },
  },
  errorAlert: {
    backgroundColor: '#FAD7CB',
    border: '1px solid #E92C2C',
    color: '#E92C2C',
    '& .MuiAlert-icon': {
      color: '#6F082C',
    },
    '& .MuiAlert-message': {
      color: '#6F082C',
    },
    '& .MuiAlert-action': {
      color: '#6F082C',
    },
  },
}));
